export const sideMappingConfig = [
  // Side Section 3
  { snId: "side-s3t1", tvId: "top-s3t1", rotation: 2 },
  { snId: "side-s3t2", tvId: "top-s3t2", rotation: 2 },
  { snId: "side-s3t3", tvId: "top-s3t3", rotation: 2 },
  { snId: "side-s3t6", tvId: "top-s3t6", rotation: 2 },
  { snId: "side-s3t7", tvId: "top-s3t7", rotation: 2 },
  { snId: "side-s3t8", tvId: "top-s3t8", rotation: 1 },

  // Side Section 4
  { snId: "side-s4t1", tvId: "top-s4t1", rotation: 1 },
  { snId: "side-s4t2", tvId: "top-s4t2", rotation: 1 },
  { snId: "side-s4t3", tvId: "top-s4t3", rotation: 1, mirror: true },
  { snId: "side-s4t4", tvId: "top-s4t4", rotation: 2, mirror: true },
  { snId: "side-s4t5", tvId: "top-s4t5", rotation: 2 },
  { snId: "side-s4t6", tvId: "top-s4t6", rotation: 2 },
  { snId: "side-s4t7", tvId: "top-s4t7", rotation: 2 },
  { snId: "side-s4t8", tvId: "top-s4t8", rotation: 2 },

  // Side Section 5
  { snId: "side-s5t1", tvId: "top-s5t1", rotation: 2 },
  { snId: "side-s5t2", tvId: "top-s5t2", rotation: 0 },
  { snId: "side-s5t3", tvId: "top-s5t3", rotation: 1, mirror: true },
  { snId: "side-s5t5", tvId: "top-s5t5", rotation: 1 },
  { snId: "side-s5t6", tvId: "top-s5t6", rotation: 1 },
];
